enum Tx {
  Agrosignal = "Агросигнал",
  Fields = "Поля",
  Field = "Поле",
  Geozone = "Геозоны",
  Technics = "Техника",
  Culture = "Культуры",
  Expenses = "Затраты",
  WorkProgress = "Ход работ",
  WorkProgressByDepartmentsAndCrops = "Ход работ по департаментам и культурам",
  CropCondition = "Состояние посевов",
  Weeds = "Сорняки",
  Diseases = "Болезни",
  Pests = "Вредители",
  Others = "Другие",
  MilkyRipeness = "Молочная спелость",
  FullRipeness = "Полная спелость",
  WaxRipeness = "Восковая спелость",
  Plan = "План",
  Fact = "Факт",
  ByArticle = "По статьям",
  Crops = "Семена",
  GSM = "ГСМ",
  Fertilizer = "Удобрения",
  SZR = "СЗР",
  All = "Все",
  NDVI = "Индексы",
  Monitoring = "Мониторинг",
  Analytics = "Аналитика",
  AllCrops = "Все культуры",
  CropRotation = "Севооборот",
  ExpensesForMonth = "Расходы за месяц",
  StateCrops = "Фазы роста",
  ExpensesByArticle = "Затраты по статьям",
  ChangeGeozone = "Редактирование геозоны",
  Partners = "Партнеры и сервисы",
  VehicleStatuses = 'Статусы техники',
  VehicleTypes = 'Типы техники'
}

export default Tx